import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 border-b border-brown/20 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-85">
      <div className="max-w-4xl mx-auto flex flex-col items-center justify-center text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center gap-2 text-forest" data-id="element-87">
          <BookOpen className="w-6 h-6" data-id="element-88" />
          <h1 className="font-handwriting text-3xl md:text-4xl font-bold tracking-wide" data-id="element-89">
            Napftagebuch
          </h1>
        </motion.div>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="font-serif text-sm md:text-base text-brown mt-1 italic" data-id="element-90">
          Ehrliche Geschichten aus dem Hundealltag
        </motion.p>
      </div>
    </header>;
}